import { useCallback, useMemo } from "react";
import { APP_LANGUAGE } from "../constants/intl.ts";

const EN_US_ORDINAL_SUFFIXES = new Map([
  ["one", "st"],
  ["two", "nd"],
  ["few", "rd"],
  ["other", "th"],
]);

/**
 * Generates an ordinal number (1st, 2nd, 3rd, etc.) based on a given number.
 */
export function useOrdinalFormatter() {
  const rules = useMemo(
    () => new Intl.PluralRules(APP_LANGUAGE, { type: "ordinal" }),
    [],
  );

  return useCallback(
    (n: number): string => {
      const rule = rules.select(n);
      const suffix = EN_US_ORDINAL_SUFFIXES.get(rule);
      return `${n}${suffix}`;
    },
    [rules],
  );
}
